// extracted by mini-css-extract-plugin
module.exports = {"About":"About_About__3w_7R","Video":"About_Video__2jYVE"};